import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,       // 5 min — matches existing CACHE_DURATION
      gcTime: 10 * 60 * 1000,         // 10 min — keep unused data in memory
      retry: 3,                        // matches MAX_RETRIES
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
